import { PropsWithChildren } from 'react';

import { useIsModifyAllowed } from '@components/IsModificationAllowed';
import { ModificationDenyTooltip } from '@components/IsModificationAllowed/components/ModificationDenyTooltip';
import { ModifyAllowedEntity } from '@components/IsModificationAllowed/types';

type IsModificationAllowedProps<T extends ModifyAllowedEntity> = {
  entity?: T | T[];
} & PropsWithChildren;

export const IsModificationAllowedByEntity = <T,>({
  entity,
  children,
}: IsModificationAllowedProps<T>) => {
  const { isModifyAllowed } = useIsModifyAllowed(entity);

  if (isModifyAllowed) {
    return children;
  }

  return <ModificationDenyTooltip>{children}</ModificationDenyTooltip>;
};
